import { Env, Region } from '@adsk/acs-sc-web-platform-api';

import { ENV_CONFIGS } from '../consts';

export function getConfig(env: Env, region: Region, key: string): string {
  const val: string | null = ENV_CONFIGS?.[region]?.[env]?.[key];

  if (!val) {
    throw new Error(
      `Cannot find env config for env: ${env}, region: ${region} and key: ${key}`,
    );
  }

  return val;
}
